import React, { Component } from "react";
import Cat from "../Components/Frames/Cat";
import FramesItems from "../Components/Frames/FramesItems";
import {GetProductCount} from '../Helpers/FramesHelpers';
import Constants from '../Config/Config';

const slides = 5;

class Frames extends Component {

  constructor(props) {
    super(props);
    this.state = {
      productsLaoded: false,
      slidesToShow: slides,
      error: null,
      frameProducts: [],
      catIncluded: []
    }
  }

  fetchProducts = (category) => {
    var catFinish = false;
    //console.log(this.state.catIncluded)
    if (this.state.catIncluded.length > 0) {
      this.state.catIncluded.some( ( item ) =>
        catFinish = category === item ? true : false
      )
    }
    //console.log(catFinish)
    if (catFinish)
      return;
    var self = this;
    if (this.state.productsLaoded)
      this.setState({productsLaoded: false});
    const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/products.json';
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      var resultfinal = data;

      resultfinal.sort(function(a, b) {
        return parseFloat(a.dimensions.width) - parseFloat(b.dimensions.width);
      })

      if (slides > resultfinal.length)
        self.setState({ slidesToShow: resultfinal.length })
      else
        self.setState({ slidesToShow: slides });

      if ( self.props.selectedFrame.size === 0 )
        self.selectFrame(resultfinal[0]);

      self.setState({
        productsLaoded: true,
        frameProducts: resultfinal,
        catIncluded: self.state.catIncluded.concat(category)
      });
      self.dispatchFramesData(resultfinal);
    }, (ex) => {
      //self.setState({ error: err.message });
    })
  }

  slidesToShow = (count) => {
    ( slides > count ) ? this.setState({ slidesToShow: count }) : this.setState({ slidesToShow: slides });
  };

  selectFrame = (product) => {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedFrame: product,
        frameLoading: false
      }
    })
  };

  dispatchFramesData(FramesData) {
    const data = FramesData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        frameProducts: data
      }
    })
  }

  fetchFrameCalc() {
    var self = this;
    fetch(Constants.URL.root+'/wp-json/acf/v2/options')
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      self.dispatchFramesCalc(data);
    }, (ex) => {
    })
  }

  dispatchFramesCalc(data) {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        framedCalc: data
      }
    })
  }

  componentDidMount() {
    this.fetchProducts();
    this.fetchFrameCalc();
  }

  render() {
    //console.log(this.state.products)
    return (
      <div className="row">
        <Cat
          {...this.props}
          slidesToShow={this.slidesToShow} />
        <div className="col-sm-9">
          <div className="tit">
            <GetProductCount
              {...this.props}
              allProductCount={this.props.productsCount} />
          </div>
          <FramesItems
            {...this.props}
            productsLaoded={this.state.productsLaoded}
            slidesToShow={this.state.slidesToShow} />
        </div>
      </div>
    );
  }
}
export default Frames;